import store from "@/store";
import axios from "axios";
import Vue from "vue";
import tokenFunc from '@/config/static/token'
var errorFn = function (err) {
  if (err.toString().indexOf("timeout") != -1) {
    Vue.prototype.$message.error("请求超时，请稍后再试");
  } else if (err.toString().indexOf("Network") != -1) {
    Vue.prototype.$message.error("连接错误，请检查网络");
  }
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = "请求错误";
        break;
      case 401:
        err.message = "未授权，请登录";
        break;
      case 403:
        err.message = "用户权限不足";
        break;
      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`;
        break;

      case 408:
        err.message = "请求超时";
        break;

      case 500:
        err.message = "服务器开个小差，请稍后再试";
        break;

      case 501:
        err.message = "服务器开个小差，请稍后再试";
        break;
      case 502:
        err.message = "服务器开个小差，请稍后再试";
        break;
      case 503:
        err.message = "服务器开个小差，请稍后再试";
        break;

      case 504:
        err.message = "服务器开个小差，请稍后再试";
        break;

      case 505:
        err.message = "HTTP版本不受支持";
        break;

      default:
        err.message = "请求失败，请稍后再试";
    }
    Vue.prototype.$message.error(err.message);
  }
  return Promise.reject(err.message);
};
let httpServer = axios.create({
  baseURL: "/api",
  timeout: 30000,
  headers: {
    "Cache-Control": "no-cache",
  },
});

let httpServer2 = axios.create({
  // baseURL:  "https://misheji.wxbjq.top/",
  baseURL: "https://www.isheji.com/",
  timeout: 30000,
  headers: {
    "Cache-Control": "no-cache",
  },
});

let httpServer3 = axios.create({
  baseURL: "https://www.microdreams.com/",
  timeout: 30000,
  headers: {
    "Cache-Control": "no-cache",
  },
});

/**
 *  请求拦截器  需要携带token信息
 */
httpServer.interceptors.request.use(
  function (config) {
    let access_token = tokenFunc.getToken();
    if (access_token) {
      config.headers.common["Authorization"] = `Bearer ${access_token}`;
      config.headers.common["token"] = `Bearer ${access_token}`;
      if (store.getters && store.getters.loginInfo) {
        config.headers.common["tid"] = store.getters.loginInfo.current_team_id;
      }
    }
    let { method, data } = config;
    let UpperMethod = String(method).toLocaleUpperCase();
    // 在请求的时候需要统一处理下token  token需携带在url接口上面\
    if (UpperMethod === "GET" && data) {
      config.url += "?";
      for (let i in data) {
        config.url += `${i}=${data[i]}&`;
      }
      config.url = config.url.slice(0, config.url.length - 1);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

httpServer3.interceptors.request.use(
  function (config) {
    // let access_token = tokenFunc.getToken();
    // if (access_token) {
    //   config.headers.common["Authorization"] = `Bearer ${access_token}`;
    //   config.headers.common["token"] = `Bearer ${access_token}`;
    //   if (store.getters && store.getters.loginInfo) {
    //     config.headers.common["tid"] = store.getters.loginInfo.current_team_id;
    //   }
    // }
    let { method, data } = config;
    let UpperMethod = String(method).toLocaleUpperCase();
    // 在请求的时候需要统一处理下token  token需携带在url接口上面\
    if (UpperMethod === "GET" && data) {
      config.url += "?";
      for (let i in data) {
        config.url += `${i}=${data[i]}&`;
      }
      config.url = config.url.slice(0, config.url.length - 1);
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 响应拦截器
httpServer.interceptors.response.use(function (response) {
  let responseJson = response.data;
  let downloadExcel = ["use_num_details_export", "use_list_export", "export", "active_details_export"].some((item) => response.config.url.indexOf(item) !== -1);
  if (!downloadExcel) {
    // 此处判断不是下载 excel 二进制文件
    if (typeof responseJson === "string") {
      Vue.prototype.$message.error("当前请求接口有误，请联系管理人员");
      return;
    }
  } else {
    const url = window.URL.createObjectURL(
      new Blob([responseJson], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
    );
    return (responseJson = {
      data: {
        url: url,
        time: new Date().getTime(),
      },
      status_code: 200,
      status: 1,
    });
  }
  let configData = {};
  let download = ["/download_excel", "/team/home/uploadimg", "/download_excel", "/team/resource/upload", "/team/member/add/excel", "/team/home/config/setting", "/team/home/upload", "/team/home/basic/setting", "/image/cutout", "/image/cutout/refine"];


  if (response.config.method === "post" && response.config.data) {
    if (!download.includes(response.config.url) && response.config.url.indexOf(".aliyuncs.com") < 0) {
      configData = JSON.parse(response.config.data);
    }
  }
  if (responseJson.status_code === 50000 || responseJson.status_code === 50001 || responseJson.status_code === 400000) {
    Vue.prototype.$message.closeAll();
    logout(responseJson);
  } else if (responseJson.status_code === 40002) {
    Vue.prototype.$msgbox·
      .confirm("无操作权限", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "check-team-messagebox",
        showClose: false,
        type: "warning",
      })
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        window.location.reload();
      });
  } else if (responseJson.status_code === 50009) {
    Vue.prototype.$msgbox
      .confirm("已切换到其他团队，无操作权限", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "check-team-messagebox",
        showClose: false,
        type: "warning",
      })
      .then(() => {
        window.location.href = responseJson.domain;
      })
      .catch(() => {
        window.location.href = responseJson.domain;
      });
  } else {
    // 如果在post请求 存在 form_validate 的时候， 那么就默认为form表单提交 input报错。
    if (!configData.form_validate && !download.includes(response.config.url)) {
      if (responseJson.status !== 1 && responseJson.status !== "1" && responseJson.status_code !== 11811) {
        let errorStr = responseJson.error || responseJson.msg || responseJson.message || "请求失败";
        Vue.prototype.$message.error(errorStr);
      }
    }
  }
  return response.data;
}, errorFn);


function logout(responseJson) {
  let access_token = tokenFunc.getToken();
  console.log(access_token, '执行这里', responseJson)
  if (access_token) {
    Vue.prototype.$message.closeAll();
    Vue.prototype.$message.error(responseJson.error);
    window.sessionStorage.clear();
    store.commit("loginInfo", null);
    tokenFunc.logout().then(code => {
      if (!code) {
        if (window.location.href.indexOf("invite") === -1) {
          Vue.prototype.staticFunc.toHref(process.env.VUE_APP_BASELogout);
        }
      }
    })
  } else {
    window.sessionStorage.clear();
    store.commit("loginInfo", null);
    // 如果没有邀请信息
    if (window.location.href.indexOf("invite") === -1) {
      Vue.prototype.staticFunc.toHref(process.env.VUE_APP_BASELogout);
    }
  }
}
export default {
  httpServer: httpServer,
  httpServer2: httpServer2,
  httpServer3: httpServer3
};
